import React from "react";
import Badge from "./Badge";
import { If } from "./Generic/If";
import { isDefined } from "./Generic/IsDefined";

interface Label {
  text: string;
  color?: string;
  icon?: string;
}

interface Props {
  labels: Label[];
}

const BadgesGroup = (props: Props) => {
  if (props.labels.length === 0) {
    return null;
  }

  return (
    <div className="BadgesGroup">
      {props.labels.map((label) => (
        <Badge key={label.text} color={label.color}>
          <If condition={isDefined(label.icon)}>
            <img src={label.icon} style={{ marginRight: 4 }} />
          </If>
          {label.text}
        </Badge>
      ))}
    </div>
  );
};

export default BadgesGroup;
